import { render, staticRenderFns } from "./DetailBankGuarantee.vue?vue&type=template&id=dff975da"
import script from "./DetailBankGuarantee.vue?vue&type=script&lang=js"
export * from "./DetailBankGuarantee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports